import type { Session } from '@change-corgi/core/session';

import { getDigitFromId } from './getDigitFromId';
import { isGuest } from './isGuest';

export function isGuestInVariantGroup(session: Session, threshold: number) {
	return isGuest(session) && session.uuid && getDigitFromId(session.uuid) < threshold;
}
